<template>
	<div class="layout-footer">
		<span class="footer-text-left">
			<small>&copy; 2026 - Plataforma Académica LEC III</small>
		</span>
		<span class="footer-text-right">
			<!-- <button class="p-link"><i class="pi pi-facebook"></i></button> -->			
			<small>v0.0.1</small>
		</span>
	</div>
</template>

<script>
	export default {
		name: "AppFooter"
	}
</script>

<style scoped>

</style>
